import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TRootState } from "../../store";
import { setRefreshCustomerEntity } from "../../reducers/customerSlice";
import { TLoanFiltersData } from "../../types";
import useGetBankPartnersData from "./useGetbankPartners";

const useMarketFilters = () => {
  const dispatch = useDispatch();
  const { getMandiEmployeesData } = useGetBankPartnersData();

  useEffect(() => {
    getMandiEmployeesData();
    // getMarketDetails();
    dispatch(setRefreshCustomerEntity());
  }, []);
  const {
    mandiEmployeesData,
    marketDetails,
    marketFilters,
    adminId,
    activeMarketTab,
  } = useSelector((state: TRootState) => ({
    mandiEmployeesData: state.marketDetails.mandiEmployeesData,
    marketDetails: state.marketDetails.allMarketsData,
    marketFilters: state.marketDetails.marketFilters,
    adminId: state.auth.adminId,
    activeMarketTab: state.marketDetails.activeMarketTab,
  }));

  const [markets, setMarkets] = useState<TLoanFiltersData[]>(
    marketFilters?.markets
  );

  const marketStatusArray = [
    "All",
    "Active",
    "Inactive",
    // 'Under Review', "Rejected"
  ];

  const [marketStatus, setMarketStatus] = useState<string[]>([]);

  const handleStatusClick = (status: string) => {
    if (status === "All") {
      if (marketStatus.includes("All")) {
        setMarketStatus([]);
      } else {
        setMarketStatus(marketStatusArray);
      }
    } else {
      let updated;

      if (marketStatus.includes("All")) {
        updated = marketStatusArray.filter((t) => t !== status && t !== "All");
      } else {
        updated = marketStatus.includes(status)
          ? marketStatus.filter((t) => t !== status)
          : [...marketStatus, status];

        if (updated.length === marketStatusArray.length - 1) {
          updated = marketStatusArray;
        }
      }
      setMarketStatus(updated);
    }
  };

  const [filterMode, setFilterMode] = useState<"All" | "">("");

  const [rms, setRms] = useState<TLoanFiltersData[]>(marketFilters?.rms);

  const marketOptions = marketDetails?.map((item) => ({
    id: item?.marketId,
    label: item?.marketName,
    value: item?.marketName?.toLowerCase()?.replace(/\s+/g, ""),
    mobile: "",
    type: "MARKET ID",
    profilePic: "",
    address: "",
  }));

  useEffect(() => {
    if (marketFilters?.status.length > 0) {
      setMarketStatus(marketFilters?.status);
    }

    if (marketFilters.markets.length > 0) {
      setMarkets(marketFilters?.markets);
    }
    if (marketFilters.rms.length > 0) {
      setRms(marketFilters?.rms);
    }

    if (marketFilters?.filterMode) {
      setFilterMode(marketFilters?.filterMode);
    }
  }, [marketFilters]);

  const rmOptions = mandiEmployeesData?.map((item) => ({
    id: item?.onoId,
    label: item?.name,
    value: item?.name?.toLowerCase()?.replace(/\s+/g, ""),
    mobile: item?.mobile?.toString(),
    type: "ONO ID",
    profilePic: item?.profilePic,
    address: item?.region,
  }));

  const isFilterApplied = () => {
    return (
      marketFilters.markets.length > 0 ||
      marketFilters.rms.length > 0 ||
      marketFilters.status.length > 0
    );
  };

  return {
    marketOptions,
    rmOptions,
    filterMode,
    setFilterMode,
    markets,
    setMarkets,
    rms,
    setRms,
    marketFilters,
    handleStatusClick,
    marketStatus,
    setMarketStatus,
    marketStatusArray,
    isFilterApplied,
    activeMarketTab,
  };
};
export default useMarketFilters;
